var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-x-transition"}},[_c('v-flex',{attrs:{"xs12":"","lg6":"","offset-lg3":""}},[_c('v-card',[_c('l-list',{attrs:{"userName":_vm.$route.params.id,"subHeader":_vm.subHeader_1,"items":_vm.states}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }